module.exports = __webpack_public_path__ + "static/media/cb.428c8396.png";